/**
 * 공통코드 테이블
 * CodeDBType.fsmdb -> link.t_code_common (Fc)
 * CodeDBType.ptldb -> ptldb.sys_cd (Cd)
 */
export enum CodeDBType {
  fsmdb = 'fsmdb',
  ptldb = 'ptldb',
}

/**
 * 캐시 코드 목록
 *
 * useCode훅의 getCodeList를 사용하려면 cachingCodes 목록에 추가해주어야 함
 *
 * CodeDBType.fsmdb인 경우 cdGroupNm에 접두사로 'fsmdb_'를 붙임
 *
 * CodeDBType.fsmdb : link.t_code_common
 * CodeDBType.ptldb : ptldb.sys_cd
 */
export const cachingCodeGroupObj = {
  fsmdb_036: { schema: CodeDBType.fsmdb, cdGroupNm: '036' }, // 화물 구분 se_cd_group
  fsmdb_067: { schema: CodeDBType.fsmdb, cdGroupNm: '067' },
  fsmdb_071: { schema: CodeDBType.fsmdb, cdGroupNm: '071' },
  fsmdb_095: { schema: CodeDBType.fsmdb, cdGroupNm: '095' },
  fsmdb_152: { schema: CodeDBType.fsmdb, cdGroupNm: '152' }, // 화물 부정수급 구분 se_cd_group
  fsmdb_158: { schema: CodeDBType.fsmdb, cdGroupNm: '158' },
  fsmdb_301: { schema: CodeDBType.fsmdb, cdGroupNm: '301' }, // 택시 구분 se_cd_group
  fsmdb_303: { schema: CodeDBType.fsmdb, cdGroupNm: '303' },
  fsmdb_499: { schema: CodeDBType.fsmdb, cdGroupNm: '499' },
  fsmdb_505: { schema: CodeDBType.fsmdb, cdGroupNm: '505' }, // 버스 구분 se_cd_group
  fsmdb_599: { schema: CodeDBType.fsmdb, cdGroupNm: '599' },
  fsmdb_702: { schema: CodeDBType.fsmdb, cdGroupNm: '702' },
  fsmdb_92H: { schema: CodeDBType.fsmdb, cdGroupNm: '92H' },
  fsmdb_CSD0: { schema: CodeDBType.fsmdb, cdGroupNm: 'CSD0' },
  fsmdb_OSS0: { schema: CodeDBType.fsmdb, cdGroupNm: 'OSS0' },
  fsmdb_175: { schema: CodeDBType.fsmdb, cdGroupNm: '175' },
  ptldb_bkup_schdl_cd: { schema: CodeDBType.ptldb, cdGroupNm: 'bkup_schdl_cd' },
  ptldb_bzenty_se_cd: { schema: CodeDBType.ptldb, cdGroupNm: 'bzenty_se_cd' },
  ptldb_bzmn_se_cd: { schema: CodeDBType.ptldb, cdGroupNm: 'bzmn_se_cd' },
  ptldb_carmdl_cd: { schema: CodeDBType.ptldb, cdGroupNm: 'carmdl_cd' },
  ptldb_dow_cd: { schema: CodeDBType.ptldb, cdGroupNm: 'dow_cd' },
  ptldb_dvi_tbl_cd: { schema: CodeDBType.ptldb, cdGroupNm: 'dvi_tbl_cd' },
  ptldb_err_cd: { schema: CodeDBType.ptldb, cdGroupNm: 'err_cd' },
  ptldb_err_dsctn_prcs_stts_cd: {
    schema: CodeDBType.ptldb,
    cdGroupNm: 'err_dsctn_prcs_stts_cd',
  },
  ptldb_err_dsctn_task_cd: {
    schema: CodeDBType.ptldb,
    cdGroupNm: 'err_dsctn_task_cd',
  },
  ptldb_excn_cyl_cd: { schema: CodeDBType.ptldb, cdGroupNm: 'excn_cyl_cd' },
  ptldb_inqry_type_cd: { schema: CodeDBType.ptldb, cdGroupNm: 'inqry_type_cd' },
  ptldb_instc_spldmd_rpot_bbs_se_cd: {
    schema: CodeDBType.ptldb,
    cdGroupNm: 'instc_spldmd_rpot_bbs_se_cd',
  },
  ptldb_instc_spldmd_rpot_dclr_type_cd: {
    schema: CodeDBType.ptldb,
    cdGroupNm: 'instc_spldmd_rpot_dclr_type_cd',
  },
  ptldb_itdc_bbs_se_cd: {
    schema: CodeDBType.ptldb,
    cdGroupNm: 'itdc_bbs_se_cd',
  },
  ptldb_koi_cd: { schema: CodeDBType.ptldb, cdGroupNm: 'koi_cd' },
  ptldb_menu_acs_authrt_cd: {
    schema: CodeDBType.ptldb,
    cdGroupNm: 'menu_acs_authrt_cd',
  },
  ptldb_menu_group_cd: { schema: CodeDBType.ptldb, cdGroupNm: 'menu_group_cd' },
  ptldb_menu_pstn_cd: { schema: CodeDBType.ptldb, cdGroupNm: 'menu_pstn_cd' },
  ptldb_menu_type_cd: { schema: CodeDBType.ptldb, cdGroupNm: 'menu_type_cd' },
  ptldb_ntcn_bbs_type_cd: {
    schema: CodeDBType.ptldb,
    cdGroupNm: 'ntcn_bbs_type_cd',
  },
  ptldb_orn_cmpny_cd: { schema: CodeDBType.ptldb, cdGroupNm: 'orn_cmpny_cd' },
  ptldb_pos_dclr_cn_cd: {
    schema: CodeDBType.ptldb,
    cdGroupNm: 'pos_dclr_cn_cd',
  },
  ptldb_prcs_stts_cd: { schema: CodeDBType.ptldb, cdGroupNm: 'prcs_stts_cd' },
  ptldb_task_cd: { schema: CodeDBType.ptldb, cdGroupNm: 'task_cd' },
  ptldb_use_guidance_bbs_se_cd: {
    schema: CodeDBType.ptldb,
    cdGroupNm: 'use_guidance_bbs_se_cd',
  },
  ptldb_user_acnt_stts_cd: {
    schema: CodeDBType.ptldb,
    cdGroupNm: 'user_acnt_stts_cd',
  },
  ptldb_user_type_cd: { schema: CodeDBType.ptldb, cdGroupNm: 'user_type_cd' },
  ptldb_whdwl_rsn_cd: { schema: CodeDBType.ptldb, cdGroupNm: 'whdwl_rsn_cd' },
  ptldb_splr_cd: { schema: CodeDBType.ptldb, cdGroupNm: 'splr_cd' },
  ptldb_gi_ty_cd: { schema: CodeDBType.ptldb, cdGroupNm: 'gi_ty_cd' },
  ptldb_layr_stts_cd: { schema: CodeDBType.ptldb, cdGroupNm: 'layr_stts_cd' },
  ptldb_otpt_frm_cd: { schema: CodeDBType.ptldb, cdGroupNm: 'otpt_frm_cd' },
  ptldb_crsys_cd: { schema: CodeDBType.ptldb, cdGroupNm: 'crsys_cd' },
  ptldb_layr_type_cd: { schema: CodeDBType.ptldb, cdGroupNm: 'layr_type_cd' },
  ptldb_link_se_cd: { schema: CodeDBType.ptldb, cdGroupNm: 'link_se_cd' },
  ptldb_db_se_cd: { schema: CodeDBType.ptldb, cdGroupNm: 'db_se_cd' },
  ptldb_chtbot_ans_evl_cd: {
    schema: CodeDBType.ptldb,
    cdGroupNm: 'chtbot_ans_evl_cd',
  }, // 챗봇 답변 평가(피드백) 태그
} as const
/**
 * upCdNm를 명시해서 코드리스트 조회하는 목록
 */
export type CachingCodesWithUpCdNm = {
  schema: CodeDBType.ptldb
  cdGroupNm: 'user_type_cd'
  upCdNm: 'USR002'
}

export type CachingCodeGroupType = keyof typeof cachingCodeGroupObj

//캐싱코드 상세정보
export type CachingCode = {
  schema: string
  cdGroupNm: string
  cdNm: string
  cdKornNm: string
  upCdNm: string
  cdSeq: number
  children?: CachingCode[]
}

//코드 구조 (getCodeList의 리턴타입)
export type CodeList = {
  [key: string]: CachingCode[]
}
